class NavigationController {
    navigateSignup() {
        this.props.navigate('/signup');
    }

    navigateLogin() {
        this.props.navigate('/');
    }

    navigateDashboard() {
        this.props.navigate('/dashboard');
    }

    navigateConfigurations() {
        this.props.navigate('/configurations');
    }

    navigateUser(userId) {
        this.props.navigate(`/users/user?userId=${userId}`);
    }

    navigateToAvailableBalance() {
        this.props.navigate('/configurations/available-balance');
    }
}

export default NavigationController;
